import wixLocation from 'wix-location';
import { session } from 'wix-storage';

//UTM Tracking ver 2
(function () {
    let str = session.getItem('utm');
    let utm = JSON.parse(str);
    if (utm) {
        wixLocation.queryParams.add({ ...utm })
    } else {
        let q = wixLocation.query;
        for (const key in q) { if (!key.startsWith('utm_')) { delete q[key] } else { q[key] = encodeURI(q[key]) } }
        if (Object.keys(q).length > 0) { session.setItem('utm', JSON.stringify(q)) }
    }
})()

$w.onReady(function () {
    wixLocation.onChange(e => {
        let str = session.getItem('utm');
        let utm = JSON.parse(str);
        if (utm) { wixLocation.queryParams.add({ ...utm }) }
    })
});

/* Jul 23
        let q = wixLocation.query;
        if (Object.keys(q).length > 0) { return }
*/